export const CONTENT_CARD_READ_UNTIL_DATE_TIME_FORMAT = "MMM DD";

export const CONTENT_TYPES_LABELS = {
  ARTICLE: "Article",
  BUNDLE: "Text set",
  EXTERNAL_LINK: "Resource",
  GENERATION_GENIUS_VIDEO: "Video",
  INTERACTIVE_VIDEO: "Video",
  INTERNAL_LINK: "Resource",
  PHET_SIMULATION: "PhET Simulation",
  TUVA_DATASET: "Tuva Dataset",
  WORKSHEET: "Worksheet",
};

export const SMART_BUNDLES_LABEL = "Browsing text set";

export const ARTICLE_STORY_MAP: { [key: string]: string } = {
  ARTICLE_INFORMATION: "Information",
  ARTICLE_EDITORIAL: "Editorial",
  ARTICLE_NEWS: "News",
  ARTICLE_FICTION: "Fiction",
  ARTICLE_POEM: "Poetry",
  ARTICLE_PHOTO: "Photo",
  ARTICLE_MAP: "Map",
};

/** Bundle labels that we use to show the "assign" or "create assignment"
    buttons on the Bundle pages.

    IMPORTANT: only compare these values with lower-case strings.
*/
export const ENABLE_ASSIGNMENT_ACTIONS_TEXT_SET_TYPES: ReadonlySet<string> =
  new Set(["text set", "instructional set"]);
